module.exports = __webpack_public_path__ + "static/media/Icon_Technology4.2ff9778f.svg";